import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDModal from "components/MDModel";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import React, { useEffect, useState } from "react";
import { JSONTree } from "react-json-tree";
import { JSONTreeTheme, JSONTreeDarkTheme } from "utils/constant";
import crudsService from "services/cruds-service";
import { Box, Skeleton } from "@mui/material";

const JsonTree = ({ open, onClose, data, isApiCall = false, darkTheme = false }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [expand, setExpand] = useState(false);
  const [loader, setLoader] = useState(false)
  const [apiData, setApiData] = useState('')

  useEffect(() => {
    async function callAPI() {
      setLoader(true)
      const response = await crudsService.getCampaignCompanyWithExternal(data);
      setApiData(response.data)
      setLoader(false)
    }
    if(isApiCall){
      callAPI()
    }
  }, [isApiCall, data])

  return (
    <MDModal open={open} onClose={onClose}>
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <MDTypography variant="h4"> Updated Data </MDTypography>
        <MDButton
          variant="gradient"
          color="dark"
          size="small"
          onClick={() => setExpand(!expand)}
        >
          {expand ? "Collapse All" : "Expand All"}
        </MDButton>
      </MDBox>
      {
        loader ?
          <Box>
            <Skeleton variant="rectangular" height="100px" sx={{ margin: '5px' }} />
            <Skeleton variant="rectangular" height="100px" sx={{ margin: '5px' }} />
            <Skeleton variant="rectangular" height="100px" sx={{ margin: '5px' }} />
            <Skeleton variant="rectangular" height="100px" sx={{ margin: '5px' }} />
          </Box>
          :
          <div
            className="jsontree"
            style={{ backgroundColor: darkMode ? "#1a2035" : "#fff" }}
          >
            <JSONTree
              data={isApiCall ? apiData : data}
              theme={darkTheme ? JSONTreeDarkTheme : JSONTreeTheme}
              invertTheme={true}
              shouldExpandNodeInitially={() => expand}
              labelRenderer={([key]) => (
                <span style={{ fontSize: "1rem" }}>{key}</span>
              )}
              valueRenderer={(raw) => (
                <span style={{ fontSize: "1rem" }}>{raw}</span>
              )}
              hideRoot={!expand}
            />
          </div>
      }
    </MDModal>
  );
};

export default JsonTree;
